import 'styled-components';
import baseTheme from '@sportnet/ui/Themes/baseTheme';

export const theme = {
  ...baseTheme,
};

export type ThemeType = typeof theme;

// Module augmentation pre styled-components v6
declare module 'styled-components' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  export interface DefaultTheme extends ThemeType {}
}
